export default "__VITE_ASSET__DfM1E7KA__"